import { TemplateTag } from "ui/components/TemplateEditor/types";
import { ContractRentTemplate, ContractRentTemplateFormValues, ContractRentTemplateItem, ContractSaleTemplate, ContractSaleTemplateFormValues, ContractSaleTemplateItem } from "./types";


/*---------------------------------------------------------------------------------------
    DOCUMENT - CONTRACT - SALE - TEMPLATE - SEARCH
-----------------------------------------------------------------------------------------*/

export const transformContractSaleTemplateRow = (res: ContractSaleTemplate): any => {
  return {
    id: res.id,
    name: res.name,
    items: res.items
  };
};

/*---------------------------------------------------------------------------------------
    DOCUMENT - CONTRACT - SALE - TEMPLATE - INFO
-----------------------------------------------------------------------------------------*/

export const transformContractSaleTemplate = (res: ContractSaleTemplate): any => {
  return {
    id: res.id,
    name: res.name,
    items: res.items.map(transformContractSaleTemplateItem)
  };
};

export const transformContractSaleTemplateItem = (res: ContractSaleTemplateItem): any => {
  return {
    id: res.id,
    title: res.title,
    content: res.content,
    isNew: res.isNew,
    deleted: res.deleted,
    order: res.order,
  };
};

export const transformContractSaleTemplateOnCreate = (res: ContractSaleTemplateFormValues): any => {
  return {
    name: res.name,
    items: res.items
  };
};

export const transformContractSaleTemplateOnUpdate = (res: ContractSaleTemplateFormValues, id: string): any => {
  return {
    id: id,
    name: res.name,
    items: res.items
  };
};


/*---------------------------------------------------------------------------------------
    DOCUMENT - CONTRACT - SALE - TEMPLATE - TAG
-----------------------------------------------------------------------------------------*/
export const transformContractSaleTemplateTag = (
  res: any
): TemplateTag => {
  return {
    key: res.key,
    label: res.label,
    description: res.description,
  };
};


/*---------------------------------------------------------------------------------------
    DOCUMENT - CONTRACT - RENT - TEMPLATE - SEARCH
-----------------------------------------------------------------------------------------*/

export const transformContractRentTemplateRow = (res: ContractRentTemplate): any => {
  return {
    id: res.id,
    name: res.name,
    items: res.items
  };
};

/*---------------------------------------------------------------------------------------
    DOCUMENT - CONTRACT - RENT - TEMPLATE - INFO
-----------------------------------------------------------------------------------------*/

export const transformContractRentTemplate = (res: ContractRentTemplate): any => {
  return {
    id: res.id,
    name: res.name,
    items: res.items.map(transformContractRentTemplateItem)
  };
};

export const transformContractRentTemplateItem = (res: ContractRentTemplateItem): any => {
  return {
    id: res.id,
    title: res.title,
    content: res.content,
    isNew: res.isNew,
    deleted: res.deleted,
    order: res.order,
  };
};

export const transformContractRentTemplateOnCreate = (res: ContractRentTemplateFormValues): any => {
  return {
    name: res.name,
    items: res.items
  };
};

export const transformContractRentTemplateOnUpdate = (res: ContractRentTemplateFormValues, id: string): any => {
  return {
    id: id,
    name: res.name,
    items: res.items
  };
};


/*---------------------------------------------------------------------------------------
    DOCUMENT - CONTRACT - RENT - TEMPLATE - TAG
-----------------------------------------------------------------------------------------*/
export const transformContractRentTemplateTag = (
  res: any
): TemplateTag => {
  return {
    key: res.key,
    label: res.label,
    description: res.description,
  };
};